import { FC, memo } from "react";

import { ServiceStatus } from "@/apis/clients";

interface Props {
  text: string;
  statusVal: ServiceStatus;
  className?: string;
}

/**
 * 色指定
 * @param {ServiceStatus} s
 */
function colorToClasses(s?: ServiceStatus) {
  switch (s) {
    case ServiceStatus.UNPUBLISHED:
      return "bg-accent-light text-accent";
    case ServiceStatus.PUBLISHING:
      return "bg-[#DAF2EE] text-primary-dark";
    case ServiceStatus.CLOSE:
      return "bg-[#D3D3D3]";
  }
}

const ServiceStatusBudgeBase: FC<Props> = ({ className, statusVal, text }) => {
  const classNames = [
    "flex mt-2 md:mt-0 pt-0.5 items-center justify-center text-center text-xs h-8 md:h-5 w-[68px] min-w-[68px] rounded-3xl",
    colorToClasses(statusVal),
    className,
  ].join(" ");

  return <span className={classNames}>{text}</span>;
};

export const ServiceStatusBudge = memo(ServiceStatusBudgeBase);
